import { createAsyncThunk } from "@reduxjs/toolkit";
import { today_missed } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";

export const fetchTodayMissed = createAsyncThunk('fetchTodayMissed', async (params, { rejectWithValue }) => {
    try {
        const response = await Axios.get(`${today_missed}`, {
            params: {
                pharmacy_id: params.pharmacy_id,
                status: params.status,
                ...(params.tab ? { tab: params.tab } : {})
            },
            ...(params.signal ? { signal: params.signal } : {})
        })
        const data = response.data
        return data;

    } catch (error) {
        if (error?.code === 'ERR_CANCELED') {
            return rejectWithValue({ aborted: true })
        }
        return rejectWithValue(error.response)
    }
});
